module.exports = __webpack_public_path__ + "static/media/jasongoodney_resume.5460bb22.pdf";